import { createStackNavigator, HeaderStyleInterpolators } from "@react-navigation/stack";
import { Platform } from "react-native";
import React from "react";
import { useTheme } from "../../hooks/use-theme";
import { useI18n } from "../../hooks/i18n-hooks";
import { getHeaderTitle } from "@react-navigation/elements";
import ScreenHeader from "../../screens/user/ScreenHeader";
import Icon from "../../components/Icon";
import WorkerDetailsScreen from "../../screens/client/WorkerDetails";
import ClientInvitationDetailsScreen from "../../screens/client/InvitationDetails";
import WorkerMissions from "../../screens/client/WorkerMissions";
import MissionDetailsScreen from "../../screens/user/MissionDetails";
import WorkerTimesheetList from "../../screens/client/WorkerTimesheetList";
import WorkerInvoices from "../../screens/client/WorkerInvoices";
import ClientWorkersScreen from "../../screens/client/Workers";
import { useCardStyleInterpolator } from "../../hooks/use-card-style-interpolator";

export type ClientWorkersTabParamList = {
    WorkerList: undefined;
    WorkerMissionList: { workerId: string };
    WorkerDetails: { workerId: string };
    ClientInvitationDetails: { invitationId: string };
    MissionDetails: { missionId: string };
    WorkerTimesheetList: { workerId: string };
    WorkerInvoices: { workerId: string };
};

const Stack = createStackNavigator<ClientWorkersTabParamList>();

const ClientWorkersNavigation = () => {
    const theme = useTheme();
    const i18n = useI18n();

    const cardStyleInterpolator = useCardStyleInterpolator();

    return (
        <Stack.Navigator
            screenOptions={{
                headerStyle: {
                    backgroundColor: theme.colors.background,
                },
                headerMode: "screen",
                headerStatusBarHeight: 0,
                headerBackButtonDisplayMode: "minimal",
                headerBackImage: () => (
                    <Icon
                        name="back"
                        size={28}
                        style={{ marginLeft: Platform.OS === "ios" ? 10 : 0, marginRight: 5 }}
                    />
                ),
                headerTitleAlign: "center",
                gestureEnabled: true,
                headerShadowVisible: false,
                cardStyleInterpolator,
                headerStyleInterpolator: HeaderStyleInterpolators.forUIKit,
            }}
        >
            <Stack.Screen
                name="WorkerList"
                component={ClientWorkersScreen}
                options={{
                    headerShown: true,
                    title: i18n.t("screens.client_profile.tabs.employees.title"),
                    header: ({ route, options }) => {
                        const title = getHeaderTitle(options, route.name);
                        return <ScreenHeader label={title} useHeaderButton />;
                    },
                }}
            />
            <Stack.Screen
                name="WorkerDetails"
                component={WorkerDetailsScreen}
                options={{
                    headerShown: true,
                    title: i18n.t(`invitation.details.title`),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="ClientInvitationDetails"
                component={ClientInvitationDetailsScreen}
                options={{
                    headerShown: true,
                    title: i18n.t(`invitation.details.title`),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="WorkerMissionList"
                component={WorkerMissions}
                options={{
                    headerShown: true,
                    title: i18n.t("screens.client_profile.tabs.missions.title"),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="MissionDetails"
                component={MissionDetailsScreen}
                options={{
                    headerShown: false,
                    title: i18n.t("mission.nav_title"),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="WorkerTimesheetList"
                component={WorkerTimesheetList}
                options={{
                    headerShown: true,
                    title: i18n.t("timesheet_list.title"),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="WorkerInvoices"
                component={WorkerInvoices}
                options={{
                    headerShown: true,
                    title: i18n.t("invoice.nav_title"),
                    gestureEnabled: true,
                }}
            />
        </Stack.Navigator>
    );
};

export default ClientWorkersNavigation;
